export function bytesToBase64Url(bytes) {
  let binary = ''
  for (let i = 0; i < bytes.length; i++) binary += String.fromCharCode(bytes[i])
  const b64 = btoa(binary)
  return b64.replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '')
}

export function base64UrlToBytes(b64) {
  const s = String(b64 ?? '').trim()
  if (!s) return null
  const padded = s.replace(/-/g, '+').replace(/_/g, '/')
  const pad = padded.length % 4
  const padded2 = pad ? padded + '='.repeat(4 - pad) : padded
  try {
    const binary = atob(padded2)
    const bytes = new Uint8Array(binary.length)
    for (let i = 0; i < binary.length; i++) bytes[i] = binary.charCodeAt(i)
    return bytes
  } catch (_) {
    return null
  }
}
